import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Alert, Layout, Modal, Switch, Table, Tooltip } from 'antd';
import { DetailForm, AuthButton, AuthButtonAuthorities } from '../../core/CoreForm';
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents';
import styles from './QualificationHoldersDetail.module.css';
import * as Module from '../../../modules/prime/qualifications-holders/qualificationHoldersModule';
import * as Model from '../../../modules/prime/qualifications-holders/qualificationHoldersModel';
import * as CONSTANTS from '../../../constants/constants';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as formatUtils from '../../../utils/formatUtils';
import * as Utils from '../../../utils/utils';
import { storedApiResult, initApiResult } from '../../../modules/core/bffApiModule';
import { storedLoginUserInfo } from '../../../modules/core/authModule'
import { initMessages, message } from '../../../modules/core/commonMessageModule';
import { setMessages } from '../../../modules/core/commonMessageModule';
import AuthButtonStyles from "../../core/css/AuthButton.module.css";
import { CcusLevelLabel } from '../../core/parts/CcusLevelLabel';

interface titleInterface {
  title: string;
}

export const QualificationHoldersDetail = (props: titleInterface) => {

  const dispatch = useDispatch();
  const dataRow = useSelector(Module.storedDataRow);
  const belongCompanyData = useSelector(Module.storedBelongCompanyDataRow);
  const apiResult = useSelector(storedApiResult);
  const loginUserInfo = useSelector(storedLoginUserInfo);
  let history = useHistory();
  let ccusLevelPeriodModalVisibleState = useSelector(Module.storedCcusLevelPeriodModalVisibleState);
  let loadingFlg = useSelector(Module.storedLoadingFlg);
  // 認定IDと登録済認定プロジェクト情報の組み合わせ
  let certificationProjectInfoMap = useSelector(Module.storedCertificationProjectInfoMap);

  useEffect(() => {
    dispatch(Module.setLoadingFlg(false));
  },
    []
  );

  useEffect(() => {
    // 所属企業が設定されていない場合、独自資格保有者協力会社一覧画面へ遷移します。
    if (belongCompanyData.belongCompanyName === "") {
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_COMPANIES);
      return;
    }
    // APIステータスが初期値の場合、詳細情報取得APIを実行します。（初期表示用の処理。loadingFlgがtrueの時は状態変更API中なのでloadingFlgの判定もする）
    if (CONSTANTS.API_STATUS_INITIAL === apiResult.status && "" === apiResult.requestMethod && !loadingFlg) {
      getDetailInfo();
    }
    // 画面更新時の詳細情報取得APIの場合、loadingFlgをfalseにする（状態変更APIでloadingFlgにtrueを設定している）
    if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod && CONSTANTS.URL_QUALIFICATIONS_HOLDERS_PRIME_LIST === apiResult.url) {
      dispatch(Module.setLoadingFlg(false));
    }

    // 詳細情報取得API実行後、APIエラーメッセージが設定されていたら一覧画面へ遷移します。
    if (dataRow.key === "" && CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" !== apiResult.errorCode && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod) {
      // API結果メッセージを遷移先画面に表示するために共通メッセージに設定します。
      const setMessage: message = {
        message: messagesUtils.getMessage(apiResult.errorCode)
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setMessages([setMessage]));
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_LIST);
    }

    // 詳細情報取得API実行後、APIエラーメッセージが設定されていたら一覧画面へ遷移します。
    if (dataRow.key === "" && CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod) {
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_COMPANIES);
    }

    // 独自資格削除API実行後、APIエラーメッセージが設定されていない場合、一覧画面に遷移して削除成功メッセージを表示します。
    if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode && CONSTANTS.REQUEST_METHOD_DELETE === apiResult.requestMethod) {
      const messageText = messagesUtils.getMessageTextFromSession();
      const messageType = messagesUtils.getMessageTypeFromSession() || CONSTANTS.MESSAGE_TYPE_SUCCESS;
      if (messageText !== null) {
        // 削除エラーメッセージがあるので、設定。画面遷移しない。
        const setMessage: message = {
          message: messageText
          , messageType: messageType
        }
        dispatch(setMessages([setMessage]));

        messagesUtils.clearSessionMessage();
      } else {
        // 削除成功メッセージを設定します。
        const setMessage: message = {
          message: messagesUtils.getMessage("SUCCESS_DELETE", ["独自資格保有者"])
          , messageType: CONSTANTS.MESSAGE_TYPE_SUCCESS
        }
        dispatch(setMessages([setMessage]));
        history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_LIST);
      }
    }

    // 独自資格一覧が0行の時の処理
    viewEmptyQualificationDetailTable();

  },
    [apiResult]
  );

  // 独自資格一覧が0行の時の処理
  const viewEmptyQualificationDetailTable = () => {
    // 0行になったとき、ant designのテーブルが作成する「No Data」行を非表示にする（0行になったとき"ant-table-placeholder"が存在する）
    const tableElem: HTMLElement | null = document.getElementById("qualificationDetailTable");
    if (tableElem != null) {
      const phRow: HTMLElement | null = tableElem.querySelector(".ant-table-placeholder");
      if (phRow != null) {
        phRow.style.display = "none";
      }
    }
  }

  // 詳細情報取得APIを実行
  const getDetailInfo = () => {
    let criteria: Model.QualificationHolderCriteria = {
      belongCompanyId: belongCompanyData.belongCompanyId,
      managementGroupId: "",
      originalQualificationName: "",
      workerId: dataRow.workerId,
      firstName: "",
      lastName: "",
      firstNameKana: "",
      lastNameKana: "",
      ccusCraftsmanId: "",
      ccusLevel: 0,
      primeCertificationNo: "",
      sortItem: "",
      sortOrder: "",
      offset: 0,
      limit: 10,
      onlyEnableQualification: "0",
      excludeRetiredWorker: "0"
    }
    dispatch(Module.getQualificationHolderDataRowAsync(criteria));
  }

  const backClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_LIST);
  }

  const editClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_HOLDERS_EDIT);
  }

  const deleteClicked = () => {
    if (!window.confirm(messagesUtils.getMessage("CONFIRM_DELETE", ["独自資格保有者"]))) {
      return;
    }
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    dispatch(initApiResult());

    let levelList: Array<Model.deleteData.LevelInfo> = [];
    dataRow.ccusLevelPeriodList.forEach((row: Model.LevelInfo) => {
      row.ccusQualificationHolderLevelId.forEach((val, idx) => {
        const levelInfo: Model.deleteData.LevelInfo = {
          ccusQualificationHolderLevelId: row.ccusQualificationHolderLevelId[idx],
          updateDatetime: row.updateDatetime[idx],
        }
        levelList.push(levelInfo);
      });
    });

    let originalQualificationList: Array<Model.deleteData.originalQualification> = [];
    dataRow.originalQualificationList.forEach((row: Model.originalQualificationRow) => {
      const certificationProjectInfoFilter = certificationProjectInfoMap.filter(val => val.certificationId == row.certificationId);
      let certificationProjectUpdateDatetimes = "";
      if (certificationProjectInfoFilter.length > 0) {
        certificationProjectUpdateDatetimes = certificationProjectInfoFilter[0].certificationProjectInfoList.map(val => val.projectUpdateDatetime).join(",");
      }
      const originalQualificationRow: Model.deleteData.originalQualification = {
        certificationId: row.certificationId
        , updateDatetime: row.updateDatetime
        , certificationProjectUpdateDatetimes: certificationProjectUpdateDatetimes
      };
      originalQualificationList.push(originalQualificationRow);
    });
    let deleteData: Model.deleteData.Request = {
      belongCompanyId: belongCompanyData.belongCompanyId
      , workerId: dataRow.workerId
      , updateDatetime: dataRow.updateDatetime
      , ccusUpdateDatetime: dataRow.ccusUpdateDatetime
      , originalQualificationList: originalQualificationList
      , levelList: levelList
    }
    dispatch(Module.deleteDataRowAsync(deleteData));
  }

  // 編集/削除ボタン表示権限有無を判定します。
  const isDisplayOperationButton = () => {
    if (loginUserInfo.authorityInfo.primeSystemMngAuth === "0") {
      // 管理者権限を持っていない場合、非表示
      return false;
    }
    return true;
  }

  /**
   * 対象プロジェクト一覧の整形
   * @param text 
   * @param row 
   * @returns 
   */
  const renderProjectName = (text: string, row: Model.originalQualificationRow) => {

    let projectNames: Array<any> = [];
    let promptTextList: Array<any> = [];
    const projectNameList: string[] = text.split(",");

    let index = 0;

    projectNameList.sort((a, b) => {
      return a > b ? 1 : -1
    }).forEach(projectName => {
      if (projectNameList.length >= 4 && index === 2) {
        // 対象プロジェクトが4件以上ある場合、3件目以降は「...」で表示する（...の行を含めてMAX3行）
        projectNames.push(<div className={styles.columnAlignLeft}>...</div>);
      } else if (projectNameList.length < 4 || index < 3) {
        // 15文字より多い場合、15文字目以降は「...」で表示する（...を含めてMAX15文字）
        projectNames.push(
          <div className={styles.columnAlignLeft}>{projectName.length > 15 ? projectName.substring(0, 14) + "..." : projectName}</div>
        );
      }

      // Tooltipに表示するメッセージの作成
      promptTextList.push(<div>{projectName}</div>);
      index++;
    });

    if (text.length >= 1) {
      return (<Tooltip placement="left" title={promptTextList}><div>{projectNames}</div></Tooltip>)
    } else {
      return <div className={styles.columnAlignLeft}>{row.certificationProjectFlag === "1" ? "なし" : "すべてのプロジェクト"}</div>
    }
  };

  // テーブル列を設定します。
  const columns = [
    {
      title: '状態'
      , dataIndex: 'status'
      , width: '12%'
      , align: 'center' as 'center'
    },
    {
      title: '独自資格名'
      , dataIndex: 'originalQualificationName'
      , key: '2'
      , width: '23%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        return (
          <div className={styles.columnAlignLeft}>{row.originalQualificationName}</div>
        )
      }
    },
    {
      title: '技能レベル適用'
      , dataIndex: 'ccusFlag'
      , key: 'ccusFlag'
      , width: '12%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        return (
          <div>{row.ccusFlag === CONSTANTS.CCUS_FLAG.ON ? "あり" : "なし"}</div>
        )
      }
    },
    {
      title: '認定日'
      , dataIndex: 'certificationDate'
      , key: '3'
      , width: '15%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        return (
          formatUtils.formatDateSlash(row.certificationDate)
        )
      }
    },
    {
      title: '認定取消日'
      , dataIndex: 'certificationCancelDate'
      , key: '4'
      , width: '15%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        return (
          formatUtils.formatDateSlash(row.certificationCancelDate)
        )
      }
    },
    {
      title: '有効期限'
      , dataIndex: 'numberOfQualifications'
      , key: '5'
      , width: '25%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        if (row.deadlineExist === CONSTANTS.EXIST_DEADLINE.NONE.code) {
          return (
            "なし"
          )
        }
        return (
          formatUtils.formatDuration(row.deadlineStartDate, row.deadlineEndDate)
        )
      }
    },
    {
      title: '対象プロジェクト'
      , dataIndex: 'certificationProjectNames'
      , key: '6'
      , align: 'center' as 'center'
      , width: '220px' // 最小の幅を指定することで最大文字数でも折り返さないようにしている
      , render: (value: string, row: Model.originalQualificationRow) => {
        return (
          renderProjectName(row.certificationProjectNames, row)
        )
      }
    },
    {
      title: ''
      , dataIndex: 'button'
      , key: '7'
      , width: '10%'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.originalQualificationRow) => {
        return <></>;
      }
    }
  ];

  // CCUSレベル適用期間モーダルのテーブル列を設定します。
  const ccusLevelPeriodColumns = [
    {
      title: '技能レベル'
      , dataIndex: 'levelName'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.LevelInfo) => {
        return (
          row.ccusLevel == 4
            ? <div>レベル４（金）</div>
            : row.ccusLevel == 3
              ? <div>レベル３（銀）</div>
              : row.ccusLevel == 2
                ? <div>レベル２（青）</div>
                : <div>レベル１（白）</div>
        )
      }
    },
    {
      title: 'スキルマップサイト上の適用期間'
      , dataIndex: 'period'
      , key: '2'
      , align: 'center' as 'center'
      , render: (value: string, row: Model.LevelInfo) => {
        return (
          row.levelStartDate.length > 0
            ? row.levelStartDate.map((val, idx) => (
              <div>{row.levelStartDate[idx]} ～ {row.levelEndDate[idx]}</div>
            ))
            : <div>－</div>
        )
      }
    },
  ];

  // 技能レベルを描画します。
  const CcusLevel = (row: Model.QualificationHolderDataRow) => {
    return <CcusLevelLabel ccusLevel={row.ccusLevel} ccusErrorFlag={row.ccusErrorFlag} />
  };

  // 建退共をスキルマップで使用すつためのForm
  // 対象を絞って使用するため、編集Formから抜き出して、個別Formにして実装（全企業対応の場合、そのまま編集Form内に実装してください）
  const MutualAidForm = () => {
    if (loginUserInfo.isMutualAidAvailableUserFlag === "1") {
      return (
        <DetailForm.Item label="建退共対象作業員">
            <span>{dataRow.mutualAidFlag === CONSTANTS.MUTUAL_AID_FLAG.ON ?  "対象作業員" : "対象外"}</span>
            <span>{dataRow.mutualAidFlag === CONSTANTS.MUTUAL_AID_FLAG.ON ?  Utils.isNullOrEmpty(dataRow.mutualAidInsuredNo) ? "未登録" : "建退共被共済者番号：" + dataRow.mutualAidInsuredNo : ""}</span>
        </DetailForm.Item>

      )
    } else {
      return (
        <></>
      )
    }
  }

  // 独自資格詳細Formを描画します。
  const DetailFormArea = () => {
    return (
      <div className={styles.contentArea} >
        <div className={styles.headline}>
          <span>基本情報</span>
        </div>
        <DetailForm>
          <DetailForm.Item label="元請認定番号">
            <span>{dataRow.primeCertificationNo}</span>
          </DetailForm.Item>

          <DetailForm.Item label="独自資格認定支店">
            <span>{dataRow.managementGroupName}</span>
          </DetailForm.Item>

          <DetailForm.Item label="氏名">
            <span>{dataRow.lastName + " " + dataRow.firstName}</span>
          </DetailForm.Item>

          <DetailForm.Item label="生年月日">
            <span>{formatUtils.formatDateSlash(dataRow.birthday)}</span>
          </DetailForm.Item>

          <DetailForm.Item label="在職中/退職済">
            <span>{dataRow.retiredFlag === CONSTANTS.RETIRED_FLAG.RETIRED ? "退職済" : "在職中"}</span>
          </DetailForm.Item>

          <DetailForm.Item label="CCUS技能者ID">
            <span>{Utils.isNullOrEmpty(dataRow.ccusCraftsmanId) ? "－" : dataRow.ccusCraftsmanId}</span>
          </DetailForm.Item>

          <DetailForm.Item label="技能レベル">
            <div style={{ width: "100%" }}>
              {CcusLevel(dataRow)}
              <span>　</span>
              {CONSTANTS.CCUS_LEVEL_MIN <= dataRow.ccusLevel && dataRow.ccusLevel <= CONSTANTS.CCUS_LEVEL_MAX ? <a style={{ textDecoration: "underline" }} onClick={() => openCcusLevelPeriodModal()}>各技能レベルの適用範囲</a> : <></>}
            </div>
          </DetailForm.Item>

          <DetailForm.Item label="CCUSデータ初回取得日">
            <span>{Utils.isNullOrEmpty(dataRow.ccusFetchedDatetime) ? "－" : formatUtils.formatDateSlash(dataRow.ccusFetchedDatetime)}</span>
          </DetailForm.Item>

          <MutualAidForm />

          <DetailForm.Item label="備考">
            <span className={styles.remarks}>{dataRow.remarks}</span>
          </DetailForm.Item>
        </DetailForm>
      </div>
    )
  }

  // CCUSレベル適用期間モーダルを表示します。
  const openCcusLevelPeriodModal = async () => {
    dispatch(Module.reflectCcusLevelPeriodModalVisibleState(true));
  }

  /** CCUSレベル適用期間モーダル表示内容 */
  const CcusLevelPeriodModalContent = () => {
    // API正常終了 
    return (
      <Table
        columns={ccusLevelPeriodColumns}
        size='small'
        dataSource={dataRow.ccusLevelPeriodList}
        pagination={false}
        className="hoverNotBackground"
        style={{ marginLeft: "20px" }}
        bordered
      />
    )
  }

  // CCUSレベル適用期間モーダルを閉じます。
  const closeCcusLevelPeriodModal = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // CCUSレベル適用期間モーダルを閉じます。
    dispatch(Module.reflectCcusLevelPeriodModalVisibleState(false));
  }

  // 独自資格詳細Formを描画します。
  const DetailTableArea = () => {
    return (
      <div className={styles.contentArea} >
        <div className={styles.headline}>
          <span>独自資格</span>
        </div>
        <Table
          id="qualificationDetailTable"
          columns={columns}
          className="hoverNotBackground"
          rowClassName={styles.qualificationRow}
          sortDirections={['ascend', 'descend']}
          size='small'
          dataSource={dataRow.originalQualificationList}
          pagination={false}
          scroll={{ x: 900 }}
          style={{ marginLeft: "20px", marginRight: "20px" }}
        />
      </div>
    )
  }

  // 所属企業を描画します。
  const BelongCompany = () => {
    return (
      <div className={styles.belongCompany}>
        <span>{"所属会社：" + belongCompanyData.belongCompanyName}</span>
      </div>
    )
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          className={AuthButtonStyles.backButtonFixed}
          onClick={backClicked}
        />
        {isDisplayOperationButton() ?
          <>
            <AuthButton
              name={"編集"}
              size={"large"}
              shape={"round"}
              onClick={editClicked}
            />
            <AuthButton
              name={"削除"}
              className={styles.customButtonColor}
              size={"large"}
              shape={"round"}
              onClick={deleteClicked}
            />
          </>
          : <></>
        }
      </FooterButtonArea>
    )
  }

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        {
          dataRow.ccusErrorFlag === CONSTANTS.CCUS_ERROR_FLAG.ON ?
            <Alert
              message={
                <>
                  <b>{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TITLE")}</b>
                  <br />{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TEXT_PRIME")}
                </>
              }
              type='warning'
              showIcon
              closable
              style={{
                width: "fit-content"
                , marginTop: "40px"
                , marginBottom: "15px"
                , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
                , textAlign: "left"
              }}
            />
            : <></>
        }
        <CommonMessage />
        <BelongCompany />
        <DetailFormArea />
        <DetailTableArea />
      </Content>
      <ButtonArea />
      <Footer />
      <Modal
        visible={ccusLevelPeriodModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={closeCcusLevelPeriodModal}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={600}
      >
        <Layout>
          <CcusLevelPeriodModalContent />
        </Layout>
      </Modal>
    </Layout>
  );
}

